<div class="cbta-signature-pad">
	<canvas #canvas width="480" height="240"></canvas>
	<button class="aa-btn clear-btn" data-variant="primary" data-size="small" (click)="clear()" matTooltip="Clear">
		<span class="aa-mat-icon">delete</span>
	</button>
</div>
